function parseDimensions (dimensions) {
  if (!dimensions) return null

  const payload = {
    alto: parseInt(dimensions.alto, 10),
    ancho: parseInt(dimensions.ancho, 10),
    largo: parseInt(dimensions.largo, 10),
    peso: parseInt(dimensions.peso, 10)
  }

  if (!payload.alto || !payload.ancho || !payload.largo || !payload.peso) return null

  return payload
}

export function packageDimensionsPayload (order) {
  if (!order || order.package !== 'otro') return null
  return parseDimensions(order.packageDimensions)
}

export function orderPackageList (order) {
  if (!order) return []

  if (Array.isArray(order.packages) && order.packages.length > 1) {
    return order.packages
  }

  if (!order.package) return []

  return [{
    package: order.package,
    packageDimensions: order.packageDimensions || null
  }]
}

export function guidePackagesReady (order) {
  const list = orderPackageList(order)
  if (!list.length) return false

  return list.every(item => {
    if (!item || !item.package) return false
    if (item.package !== 'otro') return true
    return !!parseDimensions(item.packageDimensions)
  })
}

export function guidePackagesError (order) {
  if (guidePackagesReady(order)) return ''

  if (order && Array.isArray(order.packages) && order.packages.length > 1) {
    return 'Completa las medidas de cada paquete'
  }

  if (order && order.package === 'otro') {
    return 'Completa las medidas del paquete personalizado'
  }

  return ''
}

export function guidePackagesInput (order) {
  if (!order || !Array.isArray(order.packages) || order.packages.length < 2) return null
  if (!guidePackagesReady(order)) return null

  return order.packages.map(item => {
    const input = { packagingName: item.package }
    if (item.package === 'otro') {
      input.packageDimensions = parseDimensions(item.packageDimensions)
    }
    return input
  })
}

export function packageLabel (order) {
  const list = orderPackageList(order)
  if (list.length > 1) return `${list.length} PAQ`
  return order && order.package ? order.package.toUpperCase() : 'Tamaño'
}

function customDimensionsLabel (dimensions) {
  const payload = parseDimensions(dimensions)
  if (!payload) return ''
  return `${payload.ancho}cm x ${payload.alto}cm x ${payload.largo}cm - ${payload.peso}kg`
}

export function packageDimensionsLabel (order) {
  const list = orderPackageList(order)
  if (list.length > 1) {
    return list.map(item => {
      if (!item || !item.package) return ''
      if (item.package !== 'otro') return item.package
      const dims = parseDimensions(item.packageDimensions)
      if (!dims) return 'otro'
      return `${dims.ancho}x${dims.alto}x${dims.largo}`
    }).filter(Boolean).join(' · ')
  }

  return customDimensionsLabel(order && order.packageDimensions)
}



// WEBPACK FOOTER //
// ./src/helpers/packageSize.js